import React from 'react'
import NewUserSelectionCard from '@Components/Cards/NewUserSelectionCard'
import { ICONS } from '@Const/common'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

interface NewSongwriterQuestionsProps {
    openMemberRedirectPopup(): void
}

const NewSongwriterQuestions = (props: NewSongwriterQuestionsProps) => {
    const { openMemberRedirectPopup } = props
    const navigate = useNavigate()
    return (
        <div className="user-options horizontal">
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.selfAdministeredIcon}
                title="I am self-administered"
                description={
                    <>
                        <p>
                            I manage the royalites for all of my songs. I do not have a publisher or administrator.
                            Unsure if you're self-administered? Review our Help Center article{' '}
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://help.themlc.com/en/support/what-is-a-self-administered-songwriter"
                                onClick={(e) => e.stopPropagation()}
                            >
                                here.
                            </a>
                        </p>
                    </>
                }
                onClick={() => openMemberRedirectPopup()}
            />
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.publishingDealIcon}
                title="I have a publishing deal"
                description={<p>Someone else manages my royalties. I have a publisher or administrator.</p>}
                onClick={() => navigate(Navigation.registrationSongwriter.root())}
            />
            <NewUserSelectionCard
                orientation="horizontal"
                icon={ICONS.partiallySelfAdministeredIcon}
                title="I am partially self-administered"
                description={
                    <p>
                        I manage the royalties for some of my songs myself, but others are handled through a publisher
                        or administrator. Unsure if you're self-administered? Review our Help Center article{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://help.themlc.com/en/support/what-is-a-self-administered-songwriter"
                            onClick={(e) => e.stopPropagation()}
                        >
                            here.
                        </a>
                    </p>
                }
                onClick={() => openMemberRedirectPopup()}
            />
        </div>
    )
}
export default NewSongwriterQuestions
